export { DEFAULT_CONTENTFUL_COMMON_STRINGS_CONFIG, fetchContentfulCommonStrings, } from "./fetch-common-strings";
/**
 * A convenience class that makes it easy to access Contentful common strings.
 */
export class ContentfulCommonStrings {
    constructor(mapping) {
        this.mapping = mapping;
    }
    /**
     * Return the Contentful common string with the given id in the given locale,
     * or `null` if it doesn't exist.
     */
    get(id, locale) {
        const locales = this.mapping[id];
        const result = locales && locales[locale];
        if (result === undefined)
            return null;
        return result;
    }
}
//# sourceMappingURL=index.js.map